import React from "react";

import Header from '../../components/Header/Header.jsx';
import Hero from './SectionHero/hero.jsx';
import About from './SesctionAbout/about.jsx';
import Works from './works/works.jsx';
import Testimonials from './Testimonials/testimonials.jsx';
import Blog from './SectionBlog/blog.jsx';
import Contact from '../../components/Contact/contact.jsx';
import Footer from '../../components/Footer/footer.jsx';
import Estatistic from "./SectionEstatistic/Estatistic.jsx";
import Partners from './Sectionpartners/partners.jsx'
import HeroVideo from './SectionHeroVideo/HeroVideo.jsx'

export default function Home(){
  
    return(
      <div className="App">
      <header id='header'>
        <Header />
      </header>

      <main>
        <Hero />
        <HeroVideo />
        <Works />
        <Blog />
        <Estatistic />
        <About />
        <Testimonials />
        <Partners />
        <Contact />
      </main>
      <footer id="footer">
        <Footer />
      </footer>
        </div>
    );
}